class CountrySelector extends HTMLElement {
    constructor() {
        super();
        this.priceMoney = this.querySelectorAll('price-money');
       // if(this.priceMoney.length===0) this.style.display = 'none';

        this.select = this.querySelector('select');
        this.form = document.querySelectorAll('form[action="/cart/add"]')[0];
        this.hideAllElements();
        this.setupEventListeners();
        this.checkPriceExist()
    }

    setupEventListeners() {
        this.select.addEventListener('change', this.onChange.bind(this));
        if(!this.form) this.form = document.querySelectorAll('form[action*="/cart/add"]')[0];
        this.form.addEventListener('change', this.onFormChange.bind(this));

       window.addEventListener('load', () => {
        if(this.checkPriceExist()) this.changePrice(this.select.value);
    });
    }

    checkPriceExist() {
        const id = this.form.querySelectorAll('input[name="id"]')[0].value;
        const price = document.querySelectorAll(`[data-variant-id="${id}"] price-money`);
        //const price = document.querySelectorAll(`[data-variant-id="${id}"] price-money`);
        let options = this.select.querySelectorAll("option")
        for (let opt of options){
          if(opt.value=="US") {
               opt.remove();
           }
           if(opt.value!=="US") {
               opt.style.display="none"
               const optionPrice = this.querySelector(`[data-variant-id="${id}"] price-money[data-price-country="${opt.value}"]`);
               if(optionPrice) opt.style.display="block"
           }
        }
        if(price.length>0) {
            this.style.display = 'inline';
            //data-price-country
            return true
        } else {
            this.style.display = 'none';
            return false
        }
    }
    onFormChange(event) {
        const id = this.form.querySelectorAll('input[name="id"]')[0].value;
        const variant = document.querySelectorAll(`[data-variant-id="${id}"] price-money`);
        if(this.checkPriceExist()) this.changePrice(this.select.value);
    }

    onChange(event) {
        this.changePrice(event.target.value)
    }

    changePrice(country) {
        this.hideAllElements();

        const id = this.form.querySelectorAll('input[name="id"]')[0].value;
        const variant = document.querySelectorAll(`[data-variant-id="${id}"]`)[0];
        const price = variant.querySelectorAll(`[data-price-country="${country}"]`)[0];

        if (variant && price) {
            setTimeout(function () {
                variant.style.display = "block";
                price.style.display = "block";
                document.getElementById('product-price-container').parentNode.style.display = 'none';
            }, 1000);

        } else {
            document.getElementById('product-price-container').parentNode.style.display = 'block';
        }

/*
        console.log(this.regularPrice)
        console.log(country)
        console.log(variant)
        console.log(price)*/
    }

    hideAllElements() {
        const variants = document.getElementsByClassName("variant-custom-fields"); //divsToHide is an array
        for (let i = 0; i < variants.length; i++) {
            variants[i].style.display = "none"; // depending on what you're doing
        }

        const prices = document.querySelectorAll('country-price-change price-money')

        for (let i = 0; i < prices.length; i++) {
            prices[i].style.display = "none"; // depending on what you're doing
        }
    }
}

customElements.define('country-price-change', CountrySelector);
